export default {
  playBtn: 'Play particles effects',
  stopBtn: 'Pause particle effects',
}
